import { Skeleton } from '@monksflow/monks-ui';
import {
  PROVIDER_CARD_CLASS,
  PROVIDER_GRID_CLASS,
  PROVIDER_TILE_CLASS,
} from './ProviderWhitelistCard.styles';

const PLACEHOLDER_TILES = 5;

export function ProviderWhitelistCardSkeleton() {
  return (
    <section
      data-testid="provider-whitelist-card-skeleton"
      aria-hidden
      className={PROVIDER_CARD_CLASS}
    >
      <div className="flex items-center justify-between">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-8 w-16 rounded-sm" />
      </div>
      <ul className={PROVIDER_GRID_CLASS}>
        {Array.from({ length: PLACEHOLDER_TILES }, (_, index) => (
          <li key={index} className={PROVIDER_TILE_CLASS}>
            <Skeleton className="size-8 rounded-sm" />
            <Skeleton className="h-4 w-24" />
          </li>
        ))}
      </ul>
    </section>
  );
}
